import { Estimation } from "@/types/estimation.type";
import { Tmoa } from "./../types/tmoa.type";

export const sortByType = (arrayTmoa: Tmoa[]): Tmoa[] => {
  return arrayTmoa.sort((a: Tmoa, b: Tmoa) => {
    // Extraer el número del nombre "TMOA X"
    if (a.type !== undefined && b.type !== undefined) {
      const numeroA = parseInt(a.type.replace("TMOA ", ""));
      const numeroB = parseInt(b.type.replace("TMOA ", ""));

      // Comparar los números y devolver el resultado
      return numeroA - numeroB;
    } else {
      return 0;
    }
  });
};

export const sortByTypeReverse = (arrayTmoa: Tmoa[]): Tmoa[] => {
  return arrayTmoa.sort((a: Tmoa, b: Tmoa) => {
    // Extraer el número del nombre "TMOA X"
    if (a.type !== undefined && b.type !== undefined) {
      const numeroA = parseInt(a.type?.replace("TMOA ", ""));
      const numeroB = parseInt(b.type?.replace("TMOA ", ""));

      // Comparar los números y devolver el resultado
      return numeroB - numeroA;
    } else {
      return 0;
    }
  });
};

export const getTransactionsEstimationsTmoa = (estimationsTmoa: Estimation[]) => {
  let lastValue: undefined | number = undefined;
  const contTransactions: Record<string, Record<string, number>> = {};
  const total: Record<string, number> = {};
  estimationsTmoa.forEach((estimation) => {
    if (!lastValue) {
      lastValue = estimation.value;
    } else {
      if (estimation.value && estimation.value != lastValue) {
        if (contTransactions[String(lastValue)]) {
          if (contTransactions[String(lastValue)][estimation.value]) {
            contTransactions[String(lastValue)][estimation.value] =
              contTransactions[String(lastValue)][estimation.value] + 1;
          } else {
            contTransactions[String(lastValue)][String(estimation.value)] = 1;
          }
          total[String(lastValue)] = total[String(lastValue)] + 1;
        } else {
          contTransactions[String(lastValue)] = {} as Record<string, number>;
          contTransactions[String(lastValue)][estimation.value] = 1;
          total[String(lastValue)] = 1;
        }
        lastValue = estimation.value;
      }
    }
  });

  return getPercentagesTransactions(contTransactions, total);
};

const getPercentagesTransactions = (
  contTransactions: Record<string, Record<string, number>>,
  total: Record<string, number>
) => {
  const porcentages: Record<string, Record<string, string>> = {};

  Object.keys(contTransactions).forEach((col) => {
    const rows = Object.keys(contTransactions[col]);

    // 1️⃣ porcentajes exactos
    const exacts = rows.map((row) => ({
      row,
      value: (contTransactions[col][row] / total[col]) * 100,
    }));

    // 2️⃣ parte entera
    const integers: Record<string, number> = {};
    exacts.forEach(({ row, value }) => {
      integers[row] = Math.floor(value);
    });

    // 3️⃣ calcular restante hasta 100
    const remaining = 100 - Object.values(integers).reduce((a, b) => a + b, 0);

    // 4️⃣ ordenar por mayor resto decimal
    const sortedByRemainder = exacts
      .map(({ row, value }) => ({
        row,
        remainder: value - Math.floor(value),
      }))
      .sort((a, b) => b.remainder - a.remainder);

    // 5️⃣ repartir el restante
    for (let i = 0; i < remaining; i++) {
      integers[sortedByRemainder[i].row]++;
    }

    // 6️⃣ formatear salida
    porcentages[col] = {};
    rows.forEach((row) => {
      porcentages[col][row] = integers[row] + " %";
    });
  });

  return porcentages;
};
